<template>
  <div class="deals-status">
    <v-chip
      small
      :color="buttonColor.color"
      label
      :class="'deals-status-name deals-status-name-'+buttonColor.color"
      :text-color="buttonColor.textColor"
    >
      {{ $t('deals.'+name) }}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: "DealStatus",
  props:{
    name:{
      type:String,
      default(){
        return 'new'
      },
    }
  },
  computed:{
    buttonColor(){
      switch (this.name) {
        case "new":
          return {
            color:'#DFE1E6',
            textColor:'#42526E'
          };
        case "pending":
          return {
            color:'#42526E',
            textColor:'#FFFFFF'
          };
        case "in_progress":
          return {
            color:'#DEEBFF',
            textColor:'#0747A6'
          };
        case "meeting":
          return {
            color:'#0052CC',
            textColor:'#FFFFFF'
          };
        case "choosing_property":
          return {
            color:'#FFF0B3',
            textColor:'#172B4D'
          };
        case "signing_documents":
          return {
            color:'#E3FCEF',
            textColor:'#006644'
          };
        case "completed":
          return {
            color:'#00875A',
            textColor:'#FFFFFF'
          };
        case "declined":
          return {
            color:'#96A2AE',
            textColor:'#FFFFFF'
          };
        default:
          return {
            color:'#96A2AE',
            textColor:'#FFFFFF'
          };
      }
    }
  }
}
</script>

<style scoped>

</style>
